export enum BaseButtonTypeEnum {
  /** @description 緑背景 */
  SUBMIT = 'submit',
  /** @description 白背景 */
  NEXT = 'next',
  /** @description 灰色背景 */
  CANCEL = 'cancel',
  /** @description 赤背景 */
  DELETE = 'delete',
}
